import { Component, EventEmitter, Inject, Output, ViewEncapsulation, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { Environment } from "src/app/classes/environment";
import { AuthenticationService } from "src/app/services/authentication.service";
import { ChatService } from "src/app/services/chat.service";
import { UserService } from "src/app/services/user.service";
import { DataInput, TrivUIToolsLibModule } from "@trivelope/triv-ui-tools-lib";
import { CustomerService } from "src/app/services/customer.service";


enum ChatApprovalStep { terms, nameCheck };


@Component( {
	selector: "chat-approval",
	templateUrl: "chat-approval.component.html",
	styleUrl: "./chat-approval.component.scss",
	standalone: true,
	imports: [
		MatButtonModule, TrivUIToolsLibModule, MatCheckboxModule, MatProgressSpinnerModule
	],
	encapsulation: ViewEncapsulation.None	// to allow the CSS classes inserted with innerHTML
} )
export class ChatApprovalComponent implements OnInit {


	bInProgress = false;
	bLoading = true;
	bErrorLoading = false;
	@Output() approved = new EventEmitter<boolean>();
	bError = false;

	public ChatApprovalStep = ChatApprovalStep;	// for the template
	chatApprovalStep = ChatApprovalStep.terms;
	bTermsApproved = false;
	privacyPolicyChatHtml: SafeHtml = "";
	termsOfUseChatHtml: SafeHtml = "";



	myInputs: { [name: string]: DataInput } = {};
	formGroup = new FormGroup( {
		ebeVorname: new FormControl( "", Validators.required ),
		ebeName: new FormControl( "", Validators.required )
	} );


	constructor(
		private chatService: ChatService,
		@Inject('environment') public environment: Environment,
		private userService: UserService,
		private authenticationService: AuthenticationService,
		private domSanitizer: DomSanitizer,
		private customerService: CustomerService,
		@Inject('LOCALSTORAGE') private localStorage: Storage,
	) {

		const user = this.authenticationService.getCurrentUser();

		const diFirstName = this.environment.user.find( d => d.id == "ebeVorname" );
		if( diFirstName ) {
			this.myInputs[ "ebeVorname" ] = { ...diFirstName, defaultValue: user.ebeVorname };
		}
		const diLastName = this.environment.user.find( d => d.id == "ebeName" );
		if( diLastName ) {
			this.myInputs[ "ebeName" ] = { ...diLastName, defaultValue: user.ebeName };
		}

	}
	
	ngOnInit(): void {
		this.customerService.loadLegalInformation().subscribe( data => {

			this.bLoading = false;
			this.bErrorLoading = !data;
			if( data ) {
				this.termsOfUseChatHtml = this.domSanitizer.bypassSecurityTrustHtml( data.termsOfUseChat );
				this.privacyPolicyChatHtml = this.domSanitizer.bypassSecurityTrustHtml( data.privacyPolicyChat );
			}

		} );
	}


	updateCheck( b: boolean ) {

		this.bTermsApproved = b;

	}

	clickApprove() {

		this.bInProgress = true;
		this.chatService.acceptChatConditions().subscribe( b => {

			this.bInProgress = false;
			this.bError = !b;
			if( b ) {

				this.chatApprovalStep = ChatApprovalStep.nameCheck;

				const user = this.authenticationService.getCurrentUser();
				this.formGroup.get( "ebeVorname" )?.patchValue( user.ebeVorname || "" );
				this.formGroup.get( "ebeName" )?.patchValue( user.ebeName || "" );

			}

		});

	}

	clickSaveName() {

		if( !this.formGroup.valid ) return;

		const user = this.authenticationService.getCurrentUser();
		user.ebeVorname = this.formGroup.get( "ebeVorname" )?.value || "";
		user.ebeName = this.formGroup.get( "ebeName" )?.value || "";
		
		this.bInProgress = true;

		this.userService.updateUser( user ).subscribe( result => {

			this.bInProgress = false;
			
			if( (typeof(result) == "number") || !result.ebeId ) {
				this.bError = true;
				return;
			}
			
			this.bError = false;

			const currentUser = this.authenticationService.getCurrentUser();
			currentUser.ebeVorname = result.ebeVorname || "";
			currentUser.ebeName = result.ebeName || "";
			this.localStorage.setItem( 'currentUser', JSON.stringify( currentUser ) );

			this.approved.emit( true );

		});

	}

}

